export default "__VITE_ASSET__p$9caXIB__"